import { cn } from "../../../lib/utils"

export interface SegmentProgressBarProps {
  completed: number
  total: number
  /** Items per visual segment (e.g. parallel wave size). Default 10. */
  segmentSize?: number
  isPaused?: boolean
}

export function SegmentProgressBar({
  completed,
  total,
  segmentSize = 10,
  isPaused = false,
}: SegmentProgressBarProps) {
  const segmentCount = Math.max(1, Math.ceil(total / segmentSize))

  return (
    <div className="flex gap-1" aria-hidden="true" title={`${completed}/${total}`}>
      {Array.from({ length: segmentCount }, (_, segmentIndex) => {
        const segmentStart = segmentIndex * segmentSize
        const segmentEnd = Math.min(segmentStart + segmentSize, total)
        const segmentLength = segmentEnd - segmentStart
        const filledInSegment = Math.max(0, Math.min(segmentLength, completed - segmentStart))
        const fillPct = segmentLength > 0 ? (filledInSegment / segmentLength) * 100 : 0

        return (
          <div
            key={segmentIndex}
            className="relative h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-primary/10"
          >
            <span
              className={cn(
                "absolute inset-y-0 left-0 rounded-full transition-[width] duration-500 ease-out",
                isPaused ? "bg-muted-foreground/40" : "bg-primary",
              )}
              style={{ width: `${fillPct}%` }}
            />
          </div>
        )
      })}
    </div>
  )
}
